// File actions can stay mounted through sign-out or an account change. Capture
// ownership before the first asynchronous step, while allowing token rotation.
export function createFileOpenGuard(shouldOpen) {
  const { useAuthStore } = require('@/store/auth');
  const owner = useAuthStore.getState();
  const userId = owner.user?.id;
  const generation = owner._sessionGeneration;
  const hadToken = !!owner.token;
  return () => {
    const current = useAuthStore.getState();
    return (!shouldOpen || shouldOpen()) && !current._isSigningOut
      && current.user?.id === userId && current._sessionGeneration === generation
      && !!current.token === hadToken;
  };
}
